import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import AppContext from "../../context/Context";
import { Button, Form } from 'react-bootstrap';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const useStyles = makeStyles((theme) => ({
  headingRow: {
    padding: "0.3rem 0 0.3rem 0",
    margin: "0 rem",
    background: ({ isDark }) => (isDark ? "#edf2f9" : "#edf2f9"),
  },
  mainPlusMin: {
    alignItems: "center",
    justifyContent: "flex-end",
    display: "flex",
    borderRadius:"0.25rem",
    background: ({ isDark }) => (isDark ? "#1A2639" : "#FFF"),
    height: "28px",
    border: ({ isDark }) => (`1px solid ${isDark ? '#2c3a52' : '#D9D9D9'}`),
    width: "100px",
   
  },
  inrDer : {
    padding: "5px 2px",
    margin: "0",
    lineHeight: "0",
    fontSize:"13px",
    borderRadius:"0.25rem",
    height: "28px",
    width: "23px",
    color: "#A1A1AA",
   
  },
  input: {
    textAlign: "center",
    padding: "4px",
    borderRadius:"0",
    width: "100%",
    height: "28px",
    margin: 0,
    borderRight: "none",
    borderLeft: "none",
  },
  fontText:{
    fontSize:"17px!important"
  }
}));

const PlusMinStrike = ({strikeClick, style, value}) => {
  const {
    config: { isDark },
  } = useContext(AppContext);
  const classes = useStyles({ isDark: isDark });
  const [showControls, setShowControls] = useState(false);
  const increment= () => {
    strikeClick('plus');
  }

  const decrement = () => {
      strikeClick('min');
  }
 
  return (
    <div className={classes.mainPlusMin} style={style} onMouseLeave={() => setShowControls(false)} onMouseEnter={() => setShowControls(true)}>
      <button 
        onClick={decrement} 
        style={{
          backgroundColor:(isDark ? "#1a2639" : "#FFF"),
          borderTop: `1px solid ${isDark ? '#2c3a52' : '#d9d9d9'}`,
          borderBottom: `1px solid ${isDark ? '#2c3a52' : '#d9d9d9'}`,
          borderLeft: `1px solid ${isDark ? '#2c3a52' : '#d9d9d9'}`,
          borderRight: 'none',
          borderBottomRightRadius: 0,
          borderTopRightRadius: 0,
          visibility: showControls ? 'visible' : 'hidden',
          pointerEvents: showControls ? 'auto' : 'none'
        }} 
        className={classes.inrDer}
        onMouseEnter={() => setShowControls(true)}
      >
        <RemoveIcon icon="minus" className={classes.fontText}/>
      </button>
      <Form.Group >
        <Form.Control
            value={value}
            name="grpName"
            type="number"
            className={classes.input+" qty_inp"}
            onMouseEnter={() => setShowControls(true)}
        />
      </Form.Group>
      <button 
        onClick={increment} 
         style={{
          backgroundColor:(isDark ? "#1a2639" : "#FFF"),
          borderTop: `1px solid ${isDark ? '#2c3a52' : '#d9d9d9'}`,
          borderBottom: `1px solid ${isDark ? '#2c3a52' : '#d9d9d9'}`,
          borderRight: `1px solid ${isDark ? '#2c3a52' : '#d9d9d9'}`,
          borderLeft: 'none',
          borderBottomLeftRadius: 0,
          borderTopLeftRadius: 0,
          visibility: showControls ? 'visible' : 'hidden',
          pointerEvents: showControls ? 'auto' : 'none'
         }}  
         className={classes.inrDer}
         onMouseEnter={() => setShowControls(true)}
        >
        <AddIcon icon="plus" className={classes.fontText}/>
    </button>
    </div>
  );
};

export default PlusMinStrike;
